<template>
  <div class="home">
    <SwiperComponent :images="bannerList"></SwiperComponent>
    <!-- 我们的产品 -->
    <div class="mygoods">
      <div class="mygoods-top">
        <div class="mygoods-tlt">{{ goodsInfo.TITLE }}</div>
        <div class="gd" @click="goLists">{{ $t("home.Seemore") }}</div>
      </div>
      <div class="mygoods-info">
        <div class="mygoods-left">
          <div class="left-title">{{ goodsInfo.MODULE_LEFT?.TITLE }}</div>
          <div class="left-mask">
            {{ goodsInfo.MODULE_LEFT?.PAGE_PLATE_CONFIG_CONTENT }}
          </div>
          <div class="left-btn" @click="goLists">
            {{ $t("home.Viewdetails") }}
          </div>
        </div>
        <div class="mygoods-right">
          <div
            class="mygoods-right-item"
            v-for="(item, index) in hotList.slice(0, 4)"
            :key="index"
            @click="goHotDetail(item)"
          >
            <div class="goods-cate">{{ item.name }}</div>
            <div class="goods-cate">{{ item.description }}</div>
            <img class="goods-pic" :src="$urlImg(item.coverImg)" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 资质荣誉 -->
    <div class="zizhi">
      <div class="zz-tlt">{{ honorInfo.TITLE }}</div>
      <el-carousel type="card" indicator-position="outside">
        <el-carousel-item
          v-for="item in honorInfo.ATLAS?.children"
          :key="item.id"
        >
          <img :src="$urlImg(item.message)" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 技术与服务 -->
    <!-- <div class="service">
      <div class="service-mask">
        <div class="service-tlt">{{ serveInfo.TITLE }}</div>
        <div class="service-tltmask">
          {{ serveInfo.PAGE_PLATE_CONFIG_CONTENT }}
        </div>
      </div>
      <div class="service-list">
        <div
          class="service-item"
          v-for="(item, index) in serveInfo.MODULE_RIGHT?.children"
          :key="index"
          @click="goServeLink(item.US_COVER.externalLink)"
        >
          <img
            class="service-icon"
            :src="$urlImg(item.US_COVER.message)"
            alt=""
          />
          <div class="service-itemtlt">{{ item.TITLE }}</div>
          <div class="service-itemmask">
            {{ item.PAGE_PLATE_CONFIG_CONTENT }}
          </div>
        </div>

        <div class="hengxian"></div>
        <div class="shuxian"></div>
      </div>
      <img class="service-banner" :src="$urlImg(serveInfo.US_COVER)" alt="" />
    </div> -->
    <!-- 关于我们 -->
    <div class="aboutus">
      <div class="aboutus-jianjie">
        <div class="jianjie-tlt">{{ companyInfo.TITLE }}</div>
        <div class="jianjie-mask">
          {{ displayedText }}
          <span @click="goAboutus">{{ $t("home.Seemore") }}></span>
        </div>
      </div>
      <div class="aboutus-number">
        <div class="aboutus-video">
          <video
            ref="videoPlayer"
            autoplay
            controls
            @play="onPlay"
            @pause="onPause"
            :src="companyInfo.VIDEO_LINK"
          >
            <source :src="companyInfo.VIDEO_LINK" type="video/mp4" />
          </video>
        </div>
        <div class="aboutusnum">
          <div
            class="aboutusnum-item"
            v-for="(item, index) in companyInfo.PAGE_PLATE_ARRAY?.children"
            :key="index"
          >
            <div class="num-item">
              <div class="unm-left">
                <img
                  class="num-itemicon"
                  :src="$urlImg(item.US_COVER)"
                  alt=""
                />
                <div class="unm-lefttlt">{{ item.TITLE }}</div>
              </div>
              <div class="nums">{{ item.PAGE_PLATE_TITLE }}</div>
            </div>
            <div class="num-right">
              <div class="num-right-top">{{ item.PAGE_PLATE_DESCRIPTION }}</div>
              <div class="num-right-bot">
                {{ item.PAGE_PLATE_CONFIG_CONTENT }}
              </div>
            </div>
          </div>
          <!-- <div class="aboutusnum-item">
            <div class="num-item">
              <img
                class="num-itemicon"
                src="../assets/image/home/diqu.png"
                alt=""
              />
              <div class="nums">45000+</div>
            </div>
            <div class="num-right">
              <div class="num-right-top">45000+</div>
              <div class="num-right-bot">公司成立于河南郑州市。</div>
            </div>
          </div>
          <div class="aboutusnum-item">
            <div class="num-item">
              <img
                class="num-itemicon"
                src="../assets/image/home/rongliang.png"
                alt=""
              />
              <div class="nums">8000+</div>
            </div>
            <div class="num-right">
              <div class="num-right-top">8000+</div>
              <div class="num-right-bot">公司成立于河南郑州市。</div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="fa-tlt">{{ solutionInfo.TITLE }}</div>
      <div class="an-info">
        {{ solutionInfo.PAGE_PLATE_CONFIG_CONTENT }}
      </div>
      <div class="fa-banners">
        <img class="fa-banner" :src="$urlImg(solutionInfo.US_COVER)" alt="" />
      </div> -->
    </div>
    <!-- 案例 -->
    <div class="anli">
      <div class="plate">
        <div class="plate-tlt">{{ anliInfo.PAGE_PLATE_DESCRIPTION }}</div>
        <div class="plate-xian"></div>
      </div>
      <div class="al-tlt" @click="goCase">{{ anliInfo.TITLE }}</div>
      <div class="al-info">
        {{ anliInfo.PAGE_PLATE_CONFIG_CONTENT }}
      </div>
    </div>
    <!-- 案例轮播 -->
    <div class="cate-lunbo">
      <!-- @slide-click="(item) => seleCate(item.id)" -->
      <SimpleSwiper
        class="case-lists"
        :dataList="projectcases"
        :slides-per-view="3"
        :base-space-between="10"
        :adaptive-space-between="true"
        :autoplay="true"
        :autoplay-delay="5000"
        :navigation="true"
        :loop="true"
      >
        <template v-slot:slide="{ item }">
          <div class="case-item" @click="goCaseDetail(item.id)">
            <LazyImg :src="$urlImg(item.coverUrl)" :data-url="item.coverUrl" />
          </div>
        </template>
      </SimpleSwiper>
    </div>
    <!-- 新闻详情 -->
    <div class="news">
      <div class="news-tlt">{{ newInfo.TITLE }}</div>
      <div class="news-list">
        <div
          class="new-item"
          v-for="(item, index) in companynews.slice(0, 3)"
          :key="index"
          @click="goDetail(item.id)"
        >
          <img class="new-pic" :src="$urlImg(item.coverUrl)" alt="" />
          <div class="new-itemtlt">{{ item.title }}</div>
          <div class="new-iteminfo">
            <div class="new-itemmask">
              {{ item.subTitle }}
            </div>
            <img class="new-next" src="../assets/image/home/next.png" alt="" />
          </div>
          <div class="item-label">
            <div class="moon">{{ item.month }}</div>
            <div class="year">{{ item.year }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <qrcode /> -->
  </div>
</template>
<script>
import {
  homeModuleInfo,
  bannerInfo,
  categoryList,
  catgoryRecommend,
  aboutModuleInfo,
  recommendhome,
} from "@/api/index";
import SwiperComponent from "../components/SwiperComponent.vue";
import SimpleSwiper from "../components/SimpleSwiper.vue";
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import LazyImg from "@/components/LazyImg.vue";
// import qrcode from "@/components/qrcode.vue";
export default {
  name: "HomeView",
  data() {
    return {
      bannerList: [],
      anliInfo: {}, //案例
      newInfo: {}, //新闻
      goodsInfo: {}, //产品
      serveInfo: {}, //产品
      anliList: [
        {
          path: require("../assets/image/home/demo.png"),
        },
        {
          path: require("../assets/image/home/demo2.png"),
        },
        {
          path: require("../assets/image/home/demo3.png"),
        },
      ],
      Recommend: {
        catgoryCodes: "industry_news",
        language: localStorage.getItem("lang"),
      },
      Recommend2: {
        catgoryCodes: "company_news",
        language: localStorage.getItem("lang"),
      },
      Recommend3: {
        catgoryCodes: "project_cases",
        language: localStorage.getItem("lang"),
      },
      industrynews: [],
      companynews: [],
      projectcases: [],
      hotList: [],
      companyInfo: {},
      honorInfo: {},
      solutionInfo: {},
    };
  },
  components: { SwiperComponent, SimpleSwiper, LazyImg },
  computed: {
    // 截取文本的长度
    maxLength() {
      return 200; // 你可以根据需要调整
    },
    // 是否需要显示“更多”按钮
    shouldShowMore() {
      return (
        this.companyInfo.PAGE_PLATE_CONFIG_CONTENT?.length > this.maxLength
      );
    },
    // 显示的文本内容
    displayedText() {
      if (this.showFull || !this.shouldShowMore) {
        return this.companyInfo.PAGE_PLATE_CONFIG_CONTENT;
      }
      return (
        this.companyInfo.PAGE_PLATE_CONFIG_CONTENT.slice(0, this.maxLength) +
        "..."
      );
    },
  },
  mounted() {},
  created() {
    this.homeModuleInfo();
    this.bannerInfo();
    this.catgoryRecommend();
    this.catgoryRecommend2();
    this.catgoryRecommend3();
    this.hotrecommend();
    this.aboutModuleInfo();
  },
  methods: {
    goServeLink(url) {
      // window.open(url, "noopener,noreferrer");
      window.location.href = url;
    },
    goHotDetail(item) {
      this.$router.push(
        {
          path: "/introduce",
          query: { id: item.id },
        },
        () => {}
      );
    },
    onPlay() {
      // console.log('play')
    },
    onPause() {
      // console.log('pause')
    },
    goDetail(id) {
      this.$router.push(
        {
          path: "/NewDetail",
          query: { id: id },
        },
        () => {}
      );
    },
    aboutModuleInfo() {
      aboutModuleInfo({
        language: localStorage.getItem("lang"),
        moduleCode: "ABOUNT_US",
      }).then((res) => {
        if (res.code == 200) {
          this.companyInfo = res.data.COMPANY_INTRO;
          this.honorInfo = res.data.US_HONOR;
          this.solutionInfo = res.data.SOLUTION;
        }
      });
    },
    hotrecommend() {
      recommendhome({
        language: localStorage.getItem("lang"),
      }).then((res) => {
        if (res.code == 200) {
          this.hotList = res.data;
        }
      });
    },
    catgoryRecommend() {
      catgoryRecommend(this.Recommend).then((res) => {
        if (res.code == 200) {
          this.industrynews = res.data;
        }
      });
    },
    catgoryRecommend2() {
      catgoryRecommend(this.Recommend2).then((res) => {
        if (res.code == 200) {
          this.companynews = res.data;
          this.companynews.forEach((ele) => {
            ele.year = ele.releaseTime.substring(0, 4);
            ele.month = ele.releaseTime.substring(5, 7);
          });
        }
      });
    },
    catgoryRecommend3() {
      catgoryRecommend(this.Recommend3).then((res) => {
        if (res.code == 200) {
          this.projectcases = res.data;
        }
      });
    },
    goCase() {
      this.$router.push(
        {
          path: "/case",
        },
        () => {}
      );
    },
    goAboutus() {
      sessionStorage.setItem("navIdx", 4);
      this.$store.commit("setSelectedNav", 4);
      this.$router.push(
        {
          path: "/aboutUs",
        },
        () => {}
      );
    },
    goLists() {
      sessionStorage.setItem("navIdx", 1);
      this.$store.commit("setSelectedNav", 1);
      this.$router.push(
        {
          path: "/goodsList",
        },
        () => {}
      );
    },
    goCaseDetail(id) {
      this.$router.push(
        {
          path: "/NewDetail",
          query: { id: id },
        },
        () => {}
      );
    },
    categoryList() {
      categoryList().then((res) => {
        if (res.code == 200) {
          console.log(res);
        }
      });
    },
    bannerInfo() {
      bannerInfo({
        bCode: "INDEX_BANNER",
        language: localStorage.getItem("lang"),
      }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.bannerList = res.data;
        }
      });
    },
    homeModuleInfo() {
      homeModuleInfo({
        language: localStorage.getItem("lang"),
        moduleCode: "PAGE_INDEX",
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.anliInfo = res.data.CUSTOMER_CASE;
          this.newInfo = res.data.NEWS;
          this.goodsInfo = res.data.PRODUCT_CENTER;
          this.serveInfo = res.data.TECHNOLOGY_SERVICES;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/home.css";
.home {
  overflow: hidden;
  // padding-bottom: 60px;
}
.unm-lefttlt {
  width: 50px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  //line-height: 23px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.mygoods {
  width: 100%;
  height: 1045px;
  background-image: url("../assets/image/home/bg.png");
  background-size: 100% 100%;
  padding: 47px 240px 0 238px;
  .mygoods-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .mygoods-tlt {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 53px;
      color: #313335;
      line-height: 60px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .gd {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 24px;
      color: #313335;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
  }
  .mygoods-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // flex-wrap: wrap;
    margin-top: 84px;
    .mygoods-left {
      width: 400px;
      .left-title {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 700;
        font-size: 48px;
        color: #117be0;
        // line-height: 17px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 48px;
      }
      .left-mask {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 24px;
        color: #3b3b3b;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 48px;
      }
      .left-btn {
        width: 208px;
        height: 55px;
        background: #117be0;
        border-radius: 5px 5px 5px 5px;
        border: 1px solid #97ceff;
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 55px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }
    .mygoods-right {
      width: 900px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .mygoods-right-item {
        width: 440px;
        height: 417px;
        background: #ffffff;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #cecece;
        margin-right: 20px;
        margin-bottom: 20px;
        padding-top: 20px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .goods-cate {
          width: 100%;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #3d3d3d;
          line-height: 30px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10px;
        }
        .goods-pic {
          width: 440px;
          height: 316px;
          position: absolute;
          left: 0;
          bottom: 0;
          object-fit: cover;
        }
      }
      .mygoods-right-item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
.zizhi {
  width: 100%;
  background: #ffffff;
  padding: 0 34px;
  padding-top: 93px;
  .zz-tlt {
    width: 100%;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 53px;
    color: #313335;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 30px;
  }
  .el-carousel {
    width: 100%;
    height: auto;

    ::v-deep .el-carousel__container {
      width: 100% !important;
      height: 610px;

      .el-carousel__item {
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          display: block;
          margin: 0 auto;
          object-fit: cover;
        }
      }
      /* 非激活状态的卡片透明度 */
      .el-carousel__item.is-active {
        opacity: 1;
      }
      .el-carousel__item:not(.is-active) {
        opacity: 0.6;
      }
    }
    ::v-deep .el-carousel__indicators {
      margin-top: 44px;
      .el-carousel__indicator {
        width: 20px;
        height: 20px;
        background: #d8d8d8;
        border-radius: 50%;
        margin-right: 18px;
        flex-shrink: 0;
        padding: 0;
        .el-carousel__button {
          display: none;
        }
      }
      .is-active {
        background: #0d7cd6;
      }
    }
  }
}
.service {
  width: 100%;
  height: 943px;
  background: #ffffff;
  // padding: 0 34px;
  padding-top: 70px;
  margin-top: 150px;
  display: flex;
  position: relative;
  .service-mask {
    width: 608px;
    margin-left: 246px;
    margin-right: 202px;
    .service-tlt {
      margin-left: 45px;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 700;
      font-size: 53px;
      color: #3d3d3d;
      line-height: 100px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 9px;
    }
    .service-tltmask {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #9b9b9b;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  .service-list {
    width: 625px;
    height: 702px;
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    position: relative;
    .service-item {
      width: 250px;
      // padding: 32px;
      margin-right: 113px;
      margin-bottom: 80px;
      cursor: pointer;
      .service-icon {
        width: 150px;
        height: 150px;
        display: block;
        margin: 0 auto;
      }
      .service-itemtlt {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 28px;
        color: #3d3d3d;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 20px;
      }
      .service-itemmask {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 18px;
        color: #9b9b9b;
        line-height: 23px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 20px;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .service-item:nth-child(2n) {
      margin-right: 0;
    }
    .hengxian {
      width: 625px;
      height: 0px;
      border: 1px solid #d8d8d8;
      position: absolute;
      left: 0;
      top: 50%;
    }
    .shuxian {
      width: 0;
      height: 702px;
      border: 1px solid #d8d8d8;
      position: absolute;
      left: 50%;
      top: 0;
    }
  }
  .service-banner {
    width: 952px;
    height: 538px;
    position: absolute;
    left: 50px;
    bottom: 80px;
  }
}
.aboutus {
  width: 100%;
  height: auto;
  background: #fafafa;
  margin-top: 42px;
  padding: 58px 235px 0 244px;

  .aboutus-jianjie {
    width: 1305px;
    // float: right;
    // margin-left: auto;
    .jianjie-tlt {
      width: 100%;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 700;
      font-size: 53px;
      color: #3d3d3d;
      line-height: 77px;
      text-align: right;
      font-style: normal;
      text-transform: none;
      padding-right: 46px;
    }
    .jianjie-mask {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #9b9b9b;
      line-height: 28px;
      text-align: justify;
      font-style: normal;
      text-transform: none;
      margin-top: 19px;
      padding-bottom: 19px;
      border-bottom: 1px solid #d8d8d8;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 3;
      // overflow: hidden;
      // text-overflow: ellipsis;
      span {
        font-size: 20px;
        cursor: pointer;
        // margin-left: auto;
        float: right;
        display: inline-block;
      }
    }
  }
  .aboutus-number {
    width: 100%;
    height: 510px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 44px;
    .aboutus-video {
      width: 700px;
      height: 100%;
      // background: #9b9b9b;
      video {
        width: 100%;
        height: 100%;
      }
    }
    .aboutusnum {
      width: 707px;
      height: 100%;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .aboutusnum-item {
        width: 707px;
        height: 150px;
        display: flex;
        align-items: center;
        .num-item {
          width: 262px;
          height: 150px;
          background: #117be0;
          display: flex;
          align-items: center;
          padding: 0 28px;
          .num-itemicon {
            width: 50px;
            height: 50px;
            margin-right: 29px;
            flex-shrink: 0;
            display: block;
          }
          .nums {
            width: 150px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 700;
            font-size: 38px;
            color: #ffffff;
            // line-height: 23px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
          }
        }
        .num-right {
          margin-left: 22px;
          .num-right-top {
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 700;
            font-size: 36px;
            color: #3d3d3d;
            line-height: 23px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 20px;
          }
          .num-right-bot {
            width: 280px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            font-size: 18px;
            color: #9b9b9b;
            //line-height: 23px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .fa-tlt {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 700;
    font-size: 40px;
    color: #3d3d3d;
    line-height: 57px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 24px;
  }
  .an-info {
    width: 1186px;
    // height: 110px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #737373;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 30px;
    margin-bottom: 18px;
  }
  .fa-banners {
    width: 100%;
    height: 485px;
    .fa-banner {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.anli {
  width: 100%;
  height: 620px;
  background: #117be0;
  margin-top: 70px;
  padding: 37px 243px;
  .plate {
    display: flex;
    align-items: center;
    .plate-tlt {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 35px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .plate-xian {
      //width: 1219px;
      height: 0px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin-left: 30px;
      flex: 1;
    }

    .plate-xian {
      width: 1219px;
      height: 0px;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
  .al-tlt {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 64px;
    color: #ffffff;
    line-height: 93px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
  }
  .al-info {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 26px;
    color: #ffffff;
    line-height: 38px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 14px;
  }
}
.cate-lunbo {
  width: 100;
  height: 620px;
  position: relative;
  margin-top: -290px;
  // position: absolute;
  // top: 40px;
  // right: 0;

  .case-lists {
    width: 100%;
    height: 100%;
  }

  // margin-top: 43px;
  .case-item {
    width: 100%;
    height: 620px;
    border-radius: 15px;
    position: relative;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      // border-radius: 15px;
    }

    .hovers {
      width: 100%;
      height: 100%;
      background: rgba(28, 43, 40, 0.6);
      border-radius: 15px 15px 15px 15px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      display: flex;
      align-items: center;
      transition: opacity 0.5s ease;

      .hovers-tlt {
        max-width: 348px;
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: bold;
        font-size: 48px;
        color: #ffffff;
        line-height: 56px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 0 auto;
        // margin-top: 130px;
      }
    }
  }
  .swiper-slide:hover {
    .hovers {
      opacity: 1;
    }
  }
}
.news {
  width: 100%;
  margin-top: 82px;
  margin-bottom: 100px;
  .news-tlt {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 53px;
    color: #313335;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .news-list {
    width: 1430px;
    height: 470px;
    margin: 0 auto;
    margin-top: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .new-item {
      width: 460px;
      height: 100%;
      box-shadow: 0px 5px 15px -2px rgba(0, 0, 0, 0.1);
      border-radius: 10px 10px 10px 10px;
      position: relative;
      cursor: pointer;
      .new-pic {
        width: 100%;
        height: 334px;
        margin-bottom: 20px;
        object-fit: contain;
      }
      .new-itemtlt {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 20px;
        color: #3d3d3d;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 20px;
        margin-bottom: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .new-iteminfo {
        width: 100%;
        padding: 0 10px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .new-itemmask {
          width: 85%;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 18px;
          color: #8a8a8a;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .new-next {
          width: 30px;
          height: 30px;
        }
      }
      .item-label {
        width: 81px;
        height: 80px;
        background: rgba(13, 124, 214, 0.6);
        position: absolute;
        top: 0;
        left: 30px;
        padding: 10px 15px;
        .moon {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 700;
          font-size: 20px;
          color: #ffffff;
          //line-height: 26px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          // margin-bottom: 10px;
        }
        .year {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 700;
          font-size: 20px;
          color: #ffffff;
          //line-height: 26px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
    .new-item:hover {
      background: #0d7cd6;
      .new-itemtlt {
        color: #ffffff;
      }
      .new-itemmask {
        color: #ffffff;
      }
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .mygoods {
    padding: 0 100px !important;
    .mygoods-top {
      margin-top: 22px !important;
      line-height: 46px !important;
    }
  }
  .mygoods-info {
    .left-mask {
      font-size: 32px !important;
    }
    .mygoods-right {
      width: 1200px !important;
      .mygoods-right-item {
        width: 49% !important;
        height: 480px !important;
        .goods-cate {
          font-size: 28px !important;
          line-height: 42px !important;
        }
        .goods-pic {
          width: 100% !important;
        }
      }
    }
  }
  .service {
    height: auto !important;
    display: block !important;
    margin-top: 26px !important;
    .service-mask {
      width: 100% !important;
      margin: 0 !important;
      .service-tlt {
        margin: 0 !important;
        text-align: center !important;
      }
      .service-tltmask {
        padding: 0 46px !important;
        font-size: 28px !important;
        line-height: 46px !important;
      }
    }
    .service-banner {
      width: 100% !important;
      height: 800px !important;
      position: static !important;
      object-fit: cover !important;
    }
    .service-list {
      width: 100% !important;
      height: auto !important;
      display: flex !important;
      justify-content: space-around !important;
      margin-top: 28px !important;
      .service-item {
        margin-right: 0 !important;
        width: 22% !important;
        .service-icon {
          width: 220px !important;
          height: 220px !important;
        }
        .service-itemtlt {
          font-size: 38px;
          line-height: 56px;
        }
        .service-itemmask {
          font-size: 28px;
          line-height: 46px;
        }
      }
      .hengxian {
        display: none !important;
      }
      .shuxian {
        display: none !important;
      }
    }
  }
  .aboutus {
    height: auto !important;
    padding: 40px !important;
    .aboutus-jianjie {
      width: 100% !important;
      margin: 0 !important;
      .jianjie-tlt {
        text-align: center !important;
      }
      .jianjie-mask {
        font-size: 28px !important;
        line-height: 46px !important;
      }
    }
    .aboutus-number {
      height: auto !important;
      display: block !important;
      .aboutus-video {
        width: 100% !important;
      }
      .aboutusnum {
        width: 100% !important;
        height: auto !important;
        flex-direction: row !important;
        .aboutusnum-item {
          height: auto !important;
        }
        .num-item {
          height: 100% !important;
          flex-wrap: wrap;
          .unm-left {
            width: 100%;
            .unm-lefttlt {
              width: auto !important;
              font-size: 28px !important;
              text-align: left;
              //line-height: auto !important;
            }
          }
        }
        .num-right-bot {
          font-size: 28px !important;
          //line-height: 46px !important;
        }
      }
    }
    .fa-tlt {
      width: 100% !important;
      text-align: center !important;
      margin-top: 46px !important;
    }
    .an-info {
      width: 100% !important;
      font-size: 28px !important;
      line-height: 46px !important;
    }
  }
  .news-list {
    width: 100% !important;
    height: 610px !important;
    margin: 0 18px !important;
    margin-top: 20px !important;
    .new-item {
      width: 33% !important;
      // height: ;
      .new-pic {
        height: 434px !important;
      }
      .new-itemtlt {
        font-size: 32px !important;
        // color: #3d3d3d;
        line-height: 40px !important;
      }
      .new-itemmask {
        font-size: 28px !important;
        line-height: 46px !important;
      }
      .item-label {
        width: auto !important;
        height: auto !important;
      }
    }
  }
}
</style>
